import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installFetchInterceptor } from "@/utils/fetchInterceptor";

// Install global fetch interceptor BEFORE any component mounts — ensures every
// API call (including plain fetch() calls that predate our authFetch helper)
// automatically gets the session token from localStorage as a fallback when
// httpOnly cookies drop out mid-session.
installFetchInterceptor();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
